import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { catchError, EMPTY, first } from 'rxjs';
import { CreateTimesheetCategoryInput, TimesheetSyncProvider } from '../../../../../../graphql';
import { BxLogger } from '../../../../../core/services/bx-logger.service';
import { LaunchDarklyService } from '../../../../../core/services/launchdarkly.service';
import { Job, JobItem } from '../../../../../data/models';
import { RepoJobsService } from '../../../../../data/repositories/repo-jobs.service';
import { TimesheetApiService } from '../../../../../shared/timesheets/domain/api/timesheet.api.service';
import { DeputyTimesheetAreaModel } from '../../../../../shared/timesheets/domain/entities/timesheet-location.model';

@Component({
    selector: 'app-job-deputy-areas-modal',
    templateUrl: './job-deputy-areas-modal.component.html',
    standalone: false,
})
export class JobDeputyAreasModalComponent implements OnInit {
    // @ts-ignore TS2564
    @Input() job: Job;
    deputyAreaList: DeputyTimesheetAreaModel[] = [];
    // @ts-ignore TS2564
    jobParentItems: JobItem[];
    action = new EventEmitter();

    constructor(
        private bsModalRef: BsModalRef,
        private logger: BxLogger,
        private repoJobs: RepoJobsService,
        private launchDarklyService: LaunchDarklyService,
        private timesheetsApiService: TimesheetApiService
    ) {}

    ngOnInit(): void {
        // @ts-ignore TS2532
        this.jobParentItems = this.job.JobItems.filter((i) => {
            return !i.IsDeleted && i.ParentId === null;
        }).sort((a, b) => a.OrderNumber - b.OrderNumber);
        this.loadDeputyAreaList();
    }

    loadDeputyAreaList() {
        this.timesheetsApiService
            .getTimesheetCategories({ jobId: this.job.ID_Job, timesheetProvider: TimesheetSyncProvider.Deputy })
            .pipe(first())
            .subscribe((response) => {
                if (response.data) {
                    this.deputyAreaList = response.data.timesheetCategories.map((category) => {
                        return {
                            Id: category.id,
                            OperationalUnitName: category.name,
                        } as DeputyTimesheetAreaModel;
                    }) as DeputyTimesheetAreaModel[];
                    this.setUsedAreas();
                }
            });
    }

    createDeputyArea(selectedItem: JobItem) {
        const createCategoryPayload = {
            timesheetProvider: TimesheetSyncProvider.Deputy,
            data: [
                { key: 'company', value: this.job.TimesheetLocationId },
                { key: 'operationalUnitName', value: selectedItem.Description },
            ],
        } as CreateTimesheetCategoryInput;

        this.timesheetsApiService
            .createTimesheetCategory(createCategoryPayload)
            .pipe(
                first(),
                catchError((error) => {
                    this.logger.error(error);
                    return EMPTY;
                })
            )
            .subscribe((response) => {
                const categoryId = response?.data?.createTimesheetCategory?.timesheetCategory?.id ?? '';
                if (categoryId) {
                    this.setDeputyAreaId(selectedItem, categoryId);
                    this.logger.success('Deputy area successfully created and linked.');
                } else this.logger.error('Error adding area to Deputy. Area may already exist.');
                this.loadDeputyAreaList();
            });
    }

    setDeputyAreaId(item: JobItem, areaId?: string) {
        item.TimesheetCategoryId = areaId;
        this.repoJobs.Save(null, 'Deputy area linked').then(() => {
            this.setUsedAreas();
        });
    }

    unlinkDeputyArea(item: JobItem) {
        item.TimesheetCategoryId = null;
        this.repoJobs.Save(null, 'Deputy area unlinked').then(() => {
            this.setUsedAreas();
        });
    }

    setUsedAreas() {
        const jobItemAreaList = this.jobParentItems.filter((i) => {
            return i.TimesheetCategoryId !== null;
        });

        this.deputyAreaList.forEach((depItem) => {
            if (
                jobItemAreaList.some((i) => {
                    // @ts-ignore TS2339
                    return i.TimesheetCategoryId === depItem.Id;
                })
            ) {
                // @ts-ignore TS2339
                depItem.disabled = true;
                // @ts-ignore TS2339
            } else delete depItem.disabled;
        });
    }

    ok() {
        this.action.emit();
        this.bsModalRef.hide();
    }
}
